/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Infrastructures_SubtitleInputs */

const en_us2_infrastructures_subtitle = /** @type {(inputs: Infrastructures_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your network assets (from GIS) are listed below and ready for action. Click on 'View info' to add and edit parameters like depth and flow to visualize whats going on now and in the future! Then add 'sources'—physical or virtual sensors data—ensuring you're always in the know. Dive in and Turn On the Lights!`)
};

const en_gb2_infrastructures_subtitle = /** @type {(inputs: Infrastructures_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your network assets (from GIS) are listed below and ready for action. Click on 'View info' to add and edit parameters like depth and flow to visualise what's going on now and in the future! Then add 'sources'—physical or virtual sensor data—ensuring you're always in the know. Dive in and switch on the lights!`)
};

/**
* | output |
* | --- |
* | "Your network assets (from GIS) are listed below and ready for action. Click on 'View info' to add and edit parameters like depth and flow to visualize whats ..." |
*
* @param {Infrastructures_SubtitleInputs} inputs
* @param {{ locale?: "en-US" | "en-GB" }} options
* @returns {LocalizedString}
*/
export const infrastructures_subtitle = /** @type {((inputs?: Infrastructures_SubtitleInputs, options?: { locale?: "en-US" | "en-GB" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Infrastructures_SubtitleInputs, { locale?: "en-US" | "en-GB" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return en_gb2_infrastructures_subtitle(inputs)
	return en_us2_infrastructures_subtitle(inputs)
});